/**
 * 个人中心
 */
const App = () => import('@/module/index/layout/App.vue')
const serviceinfo = () => import('@/module/index/pages/infocenter/serviceinfo.vue')
const orginfo = () => import('@/module/index/pages/infocenter/orginfo.vue')
const setaccount = () => import('@/module/index/pages/infocenter/setaccount.vue')
const setpwd = () => import('@/module/index/pages/infocenter/setpwd.vue')

export default {
  path: '/infocenter',
  component: App,
  redirect: '/infocenter/serviceinfo',
  meta: {
    title: '',
    requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
    isback: true
  },
  children: [{
    path: '/infocenter/serviceinfo',
    component: serviceinfo
  },
  {
    path: '/infocenter/orginfo',
    component: orginfo
  },
  {
    path: '/infocenter/setaccount',
    component: setaccount
  },
  {
    path: '/infocenter/setpwd',
    component: setpwd
  }
  ]
}



// WEBPACK FOOTER //
// ./src/publicResource/router/infocenter.js